import { DeclarationPropertiesTypes } from "../../data/enums/declarationPropertiesTypes";
import { OperationRequestData } from "../../data/operationRequestData";
import { OperationModel } from "../operations/operationModel";
import { PersonInfoModel } from "../../models/person/personInfoModel";
import { ContractsModel } from "../../models/contracts/contractsModel";

/** Модель ссмены пароля */
export class ServerCommandsModel extends OperationModel {

  public account: any = null;

  public commandId: string = '';

  public bankId: string = '';

  public bankName: string = '';

  public isShowed: boolean = true;

  public personInfo!: PersonInfoModel;

  public commandState: number = 0;

  constructor(person: PersonInfoModel, contracts: ContractsModel, params: any = null) {
    super();
    // if (contracts) {
    //   this.account = contracts.getSbpInContracts()[0];
    // }
    if (params) {
      this.commandId = params.id ?? "";
      this.bankId = params.bankId ?? "";
    }
    if (person) {
      if (person.Data.DefaultOutAccount) {
        this.account = contracts.getSbpInContracts().find((acc: any) => acc.Data.ReferenceId == person.Data.DefaultOutAccount);
      }
      this.personInfo = person;
    }
  }

  private get clientResponse(): string {
    if (this.commandState === 0)
      return '';
    else if (this.commandState === 1)
      return `${this.account.Data.ReferenceId}|${this.personInfo.Data.EnableSbpIn ? '1' : '0'}`;
    else if (this.commandState === -1)
      return 'Cancel';
    return '';
  }

  /**
   * Создание запроса операции.
   */
  public createOperationRequest(): OperationRequestData {
    const ord = new OperationRequestData();
    ord.respondentCode = this.RespondentCode;
    ord.operationId = this.OperationId;

    ord.setProperty("Id", this.commandId, DeclarationPropertiesTypes.Int);
    ord.setProperty("Showed", this.isShowed, DeclarationPropertiesTypes.Boolean);
    ord.setProperty("Response", this.clientResponse, DeclarationPropertiesTypes.String);

    return ord;
  }

  /**
   * Заполнение операции данными из ответа запроса.
   * @param ord Данные запроса.
   * @param bAssign Признак assign.
   */
  public setOperationFromRequest(...args: any[]): void {
    console.log("No implemetation");
  }
}
